<!-- src/views/VoucherManagement.html -->
<div class="view-container">
  <div class="header-section">
    <div>
      <h1 class="view-title">Gestione Rimborsi</h1>
      <p class="view-desc">Sezione per la gestione dei voucher e rimborsi.</p>
    </div>
    <button class="btn-primary rounded-soft" @click="openDrawer()">
      <span>Gestisci voucher</span>
    </button>
  </div>

  <div class="table-container rounded-soft shadow-soft">
    <table class="data-table">
      <thead>
        <tr>
          <th>Codice</th>
          <th>Cliente (ID)</th>
          <th>Importo</th>
          <th>Stato</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="voucher in vouchers" :key="voucher.id">
          <td class="font-medium text-light">{{ voucher.code }}</td>
          <td class="text-muted">{{ voucher.customer_first_name }} {{ voucher.customer_last_name }}</td>
          <td class="text-light">{{ voucher.amount }} €</td>
          <td>
            <span class="status-badge" :class="voucher.is_redeemed ? 'status-inactive' : 'status-active'">
              {{ voucher.is_redeemed ? 'Utilizzato' : 'Disponibile' }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="drawer-overlay" :class="{ 'is-visible': isDrawerOpen }" @click="closeDrawer"></div>

  <div class="drawer" :class="{ 'is-open': isDrawerOpen }">
    <div class="drawer-header border-bottom">
      <h2>Rimborso Voucher</h2>
      <button class="btn-close" @click="closeDrawer">
        <X :size="20" />
      </button>
    </div>
    
    <div class="drawer-body">
      <form id="refund-form" @submit.prevent="confirmRefund">
        <div class="form-group">
          <label for="refundCode">Codice Voucher *</label>
          <input 
            type="text" 
            id="refundCode" 
            v-model="refundCode" 
            placeholder="Inserisci codice 8 caratteri"
            maxlength="12"
            @input="validateInput"
            required
          />
        </div>
      </form>
    </div>
    
    <div class="drawer-footer border-top">
      <button type="button" class="btn-secondary rounded-soft" @click="closeDrawer">Annulla</button>
      <button type="submit" form="refund-form" class="btn-primary rounded-soft" :disabled="!isCodeValid">
        Conferma Rimborso
      </button>
    </div>
  </div>
</div>